import { FC, useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { REQUEST_ERROR_EVENT } from 'lib/reportError';
import { Text } from 'views/components/UI/Text';
import { Toast } from 'views/components/UI/Toast';

const RequestErrorNotice: FC = () => {
  const [visible, setVisible] = useState(false);
  const { key } = useLocation();
  useEffect(() => {
    setVisible(false);
    const show = (): void => setVisible(true);
    window.addEventListener(REQUEST_ERROR_EVENT, show);
    return () => window.removeEventListener(REQUEST_ERROR_EVENT, show);
  }, [key]);
  return visible ? (
    <Toast onDismiss={() => setVisible(false)}>
      <Text variant="bodySmall">
        <FormattedMessage id="request-error.notice" />
      </Text>
    </Toast>
  ) : null;
};

export { RequestErrorNotice };
